import { createContext, useContext } from 'react';

/**
 * Tracks whether Navigation has already been rendered by a parent layout.
 *
 * Used by:
 * - ModuleLayout (route-level) — sets context to true after rendering Navigation
 * - Navigation — returns null if context is true (prevents duplicates)
 * - PageLayout — skips Navigation/EmailBanner if context is true, but still
 *   renders the content wrapper (preserving fullWidth, header, bg props)
 */
const NavigationRenderedContext = createContext(false);
NavigationRenderedContext.displayName = 'NavigationRendered';

export const useNavigationRendered = () => useContext(NavigationRenderedContext);
export const NavigationRenderedProvider = NavigationRenderedContext.Provider;
